import { useHistory } from 'react-router-dom';
import Segment from '../shared/segment';
import Button from '../shared/buttons/button';

function NoDeck() {
  const history = useHistory();
  return (
    <Segment textAlign='center'>
      <p>بسته‌ای برای خرید یافت نشد.</p>
      <Button
        outline
        color='red'
        content='بازگشت'
        onClick={history.goBack}
        className='mx-auto my-4'
      />
    </Segment>
  );
}

export default NoDeck;
